export default {
  computed: {
    user() {
      return this.$store.state.user;
    },
    loading() {
      return this.$store.state.loading;
    },
    page() {
      return this.$store.state.rules.page;
    },
  },
  created() {
    this.$store.dispatch('rules/getRules');
  },
};
